const ACCESS_TOKEN_KEY = 'loveline_auth_token'
const REFRESH_TOKEN_KEY = 'loveline_refresh_token'
const USER_KEY = 'loveline_user'

export interface StoredAuthUser {
  id: string
  phone: string | null
  email: string | null
  display_name: string | null
  is_new: boolean
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function storeTokens(accessToken: string, refreshToken?: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  }
}

export function storeUser(user: StoredAuthUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function getStoredUser<T = unknown>(): T | null {
  const json = localStorage.getItem(USER_KEY)
  if (!json) return null
  try {
    return JSON.parse(json) as T
  } catch {
    return null
  }
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function hasValidToken(): boolean {
  return !!getAccessToken()
}
